import { useEffect } from "react";

declare global {
  interface Window {
    ka: {
      ClientSDK: new () => {
        setupCallback: (handlers: { "collect-begin"?: (params: { MercSessId?: string }) => void }) => void;
        autoLoadEvents: () => void;
      };
    };
  }
}

const KOUNT_MERCHANAT_ID = "201706";

const StickyCard = ({ setKountSessionId }) => {
  useEffect(() => {
    //we add the class kaxsdc and data-event=load to body tag
    document.body.classList.add("kaxsdc");
    document.body.setAttribute("data-event", "load");

    // Load the external script
    const script = document.createElement("script");
    script.src = `https://ssl.kaptcha.com/collect/sdk?m=${KOUNT_MERCHANAT_ID}`;
    script.onload = () => {
      // Setup the Kount callback
      const client = new window.ka.ClientSDK();
      client.setupCallback({
        "collect-begin": function (params: object) {
          setKountSessionId(params["MercSessId"]);
        },
      });
      client.autoLoadEvents();
    };

    document.body.appendChild(script);

    // Clean up the script if the component is unmounted
    return () => {
      document.body.removeChild(script);
      // Remove the iframe(s)
    };
  }, [setKountSessionId]);

  return (
    <>
      <div className="bg-default-100 rounded-lg shadow-md p-0">
        <div id="stickyio_card" className="max-w-[400px]"></div>
      </div>
    </>
  );
};

export default StickyCard;
